import { configureStore } from '@reduxjs/toolkit';
import darkModeReducer from './darkModeSlice';
import splashReducer from './splashSlice';
import navLinksReducer from './navbarSlice';
import userReducer from './userSlice';

export interface TrackModel{
  id: number;
  title: string,
  cover:string,
  embed:string,
  oembed: string
}

export interface EventModel{
id: number;
title:string,
postcode:string,
link: string,
date: Date
}

export const store = configureStore({
    reducer: {
      darkMode: darkModeReducer,
      splash: splashReducer,
      navLinks: navLinksReducer,
      user: userReducer
    },
  });

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
